import { HTMLAttributes } from "react";

import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations/index.ts";

const rowCss = css({
    "backgroundColor": wacToken("color.neutral.light0"),
    "transition": "background-color .5s",
    "&:hover": {
        backgroundColor: wacToken("color.neutral.light100")
    }
});

export const GenericTableRow = (props: HTMLAttributes<HTMLTableRowElement>) => {
    return <tr {...props} css={rowCss} />;
};
